export default __webpack_public_path__ + "imgs/cooking.2059d863b5c2579c8fa31f243bbd0c54.svg";